import Modal from "ui-kit/src/Modal/Modal";
import { _ } from "i18n";
import { Keys } from "i18n/locales/types";

type FeedbackType = 'success' | 'warning' | 'error';

interface FeedbackModalProps {
    isOpen: boolean;
    onClose: () => void;
    message: string;
    type?: FeedbackType;
    title?: string;
    buttonText?: string;
}

const iconMap = {
    success: "icon-success icon icon-check icon-50",
    warning: "icon-new icon-blue icon-warning-new icon-50",
    error: "icon-new icon-red icon-cross icon-50"
};

export const FeedbackModal: React.FC<FeedbackModalProps> = ({ 
    isOpen, 
    onClose, 
    message, 
    type = 'success',
    title,
}) => {
    return (
        <Modal
            show={isOpen}
            onClose={onClose}
            size="sm"
            title={title}
        >
            <div className="text-center" style={{ padding: '20px' }}>
                <div style={{ marginBottom: '20px' }}>
                    <span className={iconMap[type]} />
                </div>
                <div style={{ fontSize: '16px', marginBottom: '20px' }}>
                    {message}
                </div>
            </div>
        </Modal>
    );
} 